import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class WaterLevelAttribute extends Sensor {
  public waterLevelChart: any;
  private waterLevelSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.waterLevelChart = null;
    this.waterLevelSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;

      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.waterLevelSensor, position);
      this.waterLevelSensor[position].push([timestamp, element.waterLevel]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredWaterLevel = this.waterLevelSensor.filter(series => series.length > 0);

    const positionNodeWaterLevel = this.waterLevelSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.waterLevelChart = this.getConfigChar(
      'waterLevel',
      this.getChartSeriesNewNode('Sensor', filteredWaterLevel, positionNodeWaterLevel),
      this.getRanges('waterLevel'),
      this.getLimits('waterLevel')
    );
  }

  public hasWaterLevelSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.waterLevelSensor.length &&
      this.waterLevelSensor[index].length > 0
    );
  }

  public getWaterLevelSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.waterLevelSensor.length) {
      const sensorData = this.waterLevelSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Nivel de agua', value: 'waterLevel' }
    ];
  }
}
